const EconomicAndWorkforceImpactScreen = () => {

    return(
        <p>Economic and Workforce Impact</p>
    )
}

export default EconomicAndWorkforceImpactScreen